import React from 'react'
import styled from 'styled-components'

import Heading from '../../../../LuxKit/Typography/Heading'
import BodyText from '../../../../LuxKit/Typography/BodyText'

import { rem } from 'polished'
import config from '../../../constants/config'
import ImageHero from '../../Common/ImageHero'

interface Props {
  title: string
  subheading: string
}

const Container = styled(ImageHero)`
  max-height: ${rem(200)};
`

function DestinationProductPageHeader({ title, subheading }: Props) {
  return (
    <Container id={config.searchFormSection.hotelsImageId} brightness={-30} mobileWidth="100vw" dpr={2}>
      <Heading variant="heading2" colour="neutral-eight" as="h1">{title}</Heading>
      <BodyText variant="large" colour="neutral-eight" as="h2" align="center">{subheading}</BodyText>
    </Container>
  )
}

export default DestinationProductPageHeader
